import { Person, CardMembership, AccountBalance, Dashboard } from '@mui/icons-material';

export const studentMenuItems = [
  {
    id: 'student-overview',
    label: 'Overview',
    icon: Dashboard,
  },
  {
    id: 'student-report-cards',
    label: 'Report Cards',
    icon: CardMembership,
  },
  {
    id: 'student-fees',
    label: 'Fee Statement',
    icon: AccountBalance,
  },
  {
    id: 'student-profile',
    label: 'My Profile',
    icon: Person,
  },
];
